module.exports = __webpack_public_path__ + "static/img/record.d0289dc0.png";